<template>
  <div class="shopRegister">
    <div class="shopTop">
      <div class="topLeft">
        <div class="login" @click="goLogin">亲，请登录</div>
        <div class="register" @click="goRegister">免费注册</div>
        <div class="home" @click="goHome">首页</div>
      </div>
      <div class="topRight">
        <div class="aboutUs" @click="goAboutUs">关于我们</div>
        <div class="contactUs" @click="goContactUs">联系我们</div>
        <div class="news" @click="goNews">资讯</div>
        <div class="enter" @click="goEnter">商家入驻</div>
      </div>
    </div>
    <div class="shopSearch">
      <div class="shopLogo">
        <img src="../../../../static/img/ejklogo_01.png" alt="">
      </div>
      <!-- <div class="search">
          <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div> -->
      <div class="shopLogo">
        用户注册
      </div>
    </div>
    <div class="shopGoods">
      <img src="../../../../static/img/shopRegister.png" alt="">
    </div>
    <div style="height:5rem"></div>
    <div style="height:4rem"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        input3: '',
      }
    },
    methods: {
      //去登陆
      goLogin() {
        this.$router.push({
          path: "/shopLogin",
        })
      },
      //去注册
      goRegister() {
        this.$router.push({
          path: "/shopRegister",
        })
      },
      //去关于我们
      goAboutUs() {
        const m = this.$createElement;
        this.$msgbox({
          title: '关于我们',
          message: m('p', null, [
            m('p', null, '金科生活商城，是e金科平台为您提供的综合生态服务，守护您关爱的每一个生活细节；快入手巧成团，与您的挚爱亲朋玩转金科生活圈。'),
            m('p', null, '主营家用电器、家居家纺、电子产品、箱包皮具等生活用品。 '),
          ]),
          confirmButtonText: '确定',
        })
      },
      //去联系我们
      goContactUs() {
        const h = this.$createElement;
        this.$msgbox({
          title: '联系我们',
          message: h('p', null, [
            h('p', null, '公 司 名 称：北京金保通科技有限公司 ；'),
            h('p', null, '公 司 邮 箱：http://mail.ulic.com.cn/； '),
            h('p', null, '联 系 方 式：010-59949375 '),
          ]),
          confirmButtonText: '确定',
        });
      },
      //去资讯
      goNews() {
        this.$router.push({
          path: "/shopNews",
        })
      },
      //去商家入驻
      goEnter() {
        this.$router.push({
          path: "/shopEnter",
        })
      },
      //去首页
      goHome() {
        this.$router.push({
          path: "/",
        })
      },
    }
  }

</script>
<style scoped>
  .shopRegister {
    background-image: url(//img.alicdn.com/imgextra/i2/O1CN01OWa9L21QkSRmOrCaA_!!6000000002014-2-tps-720-1607.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: auto;
    min-width: 1280px;
    width: 100%;
  }

  .shopTop {
    width: 100%;
    height: 3.2rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid #fdfdfd;
  }

  .topLeft,
  .topRight {
    display: flex;
  }

  .login,
  .register,
  .aboutUs,
  .contactUs,
  .news {
    margin-right: 2rem;
  }

  .login {
    color: red;
  }

  .shopSearch {
    height: 6rem;
    display: flex;
    /* justify-content: space-around; */
    align-items: center;
    margin-left: 10rem;
  }

  .shopLogo {
    margin-right: 1rem;
    font-size: 1.6rem;
    font-weight: 500;
  }

  .shopLogo img {
    width: 10rem;

  }

  .search {
    width: 50%;
  }

  .shopGoods {
    width: 90%;
    margin: auto;
    margin-top: 2rem;
    display: flex;

  }

  .shopGoods img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// shopRegister.vue?5abe5f36